import React from 'react';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';

import AnnotationTemplates from '../../../api/AnnotationTemplates/AnnotationTemplates';

import PageHeader from '../../atoms/PageHeader';
import AnnotationTemplateEditor from '../../components/AnnotationTemplateEditor';
import Loading from '../../components/Loading';

const NewAnnotationTemplate = ({ loading, ...rest }) => {
  if (loading) {
    return <Loading />;
  }
  return (
    <>
      <PageHeader>
        <h4>New Annotation Template</h4>
      </PageHeader>
      <AnnotationTemplateEditor {...rest} />
    </>
  );
};

NewAnnotationTemplate.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default withTracker(() => {
  const subscription = Meteor.subscribe('annotationTemplates');
  return {
    loading: !subscription.ready(),
    annotationTemplates: AnnotationTemplates.find({ deleted: { $eq: 'no' } }).fetch()
  };
})(NewAnnotationTemplate);
